export const UPDATE_SERVICE_TRANSITION = "UPDATE_SERVICE_TRANSITION";

export function updateServiceTransition(payload){
    return { type: UPDATE_SERVICE_TRANSITION, payload };
}

